import React from 'react'
import RA from 'ra-config'
import SidebarDetail from '../../sidebar-detail'
import { labelForFactor } from '../../../attributes'
import { descriptionForFactor } from '../../../config/description'
import { getSidebarGroups } from './sidebar-groups'

const TOOLTIPS = RA.content.factors.attributeInfoText

function getDescription(aggregate, region) {
  if (!aggregate) {
    return ''
  }

  return descriptionForFactor(aggregate.Name, aggregate.Category, region.value)
}

export default function FactorsSidebarDetail({ activeAggregate, region }) {
  let description = getDescription(activeAggregate, region)
  let sidebarGroups = getSidebarGroups(activeAggregate)

  return (
    <SidebarDetail
      aggregate={activeAggregate}
      tooltips={TOOLTIPS}
      getLabel={labelForFactor}
      sidebarGroups={sidebarGroups}
      description={description}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/factors/aggregate/sidebar-detail.js